export const INITIAL_REDIRECT_SESSION_KEY = "initialRedirectInfo"
export type InitialRedirectInfo = {
  eventType?: string
  eventId?: string
  marketId?: string
}

export const parseFromUrl = (): InitialRedirectInfo => {
  const currentUrl = window.location.href
  const url = new URL(currentUrl)

  return {
    eventType: url.searchParams.get("eventType") || undefined,
    eventId: url.searchParams.get("eventId") || undefined,
    marketId: url.searchParams.get("marketId") || undefined
  }
}

export const removeParseFromUrl = () => {
  const url = new URL(window.location.href)
  url.searchParams.delete("eventType")
  url.searchParams.delete("eventId")
  url.searchParams.delete("marketId")
  window.history.replaceState({}, document.title, url.toString())
}

export default {
  parseFromUrl,
  removeParseFromUrl,
  INITIAL_REDIRECT_SESSION_KEY
}
